import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import BackrsFilledDropShadow from '@backrs_ui/common-ui/src/assets/images/backrs-filled-drop-shadow.svg';
import { EmulationChip } from '@backrs_ui/common-ui/src/atoms/EmulationChip';
import { AppIcon, ICON_SIZES } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { Box, Typography } from '@mui/material';
import { SIDEBAR_MOBILE_HEIGHT } from './sidebar.constants';
var SIDEBAR_STRINGS = appStrings.modules.backrsSidebar;
export var SidebarMobileTopBar = function (_a) {
    var onMenuClick = _a.onMenuClick, onLogoClick = _a.onLogoClick, isEmulating = _a.isEmulating, mobileNavItems = _a.mobileNavItems;
    return (_jsx(Box, { sx: containerSx(isEmulating), children: _jsxs(Box, { sx: logoContainerSx, children: [_jsx(Box, { component: "img", src: BackrsFilledDropShadow, alt: "Backrs Logo", sx: backrsLogoImageSx, onClick: onLogoClick }), _jsxs(Box, { sx: logoTextContainerSx, children: [_jsxs(Box, { sx: logoTextWithChipSx, children: [_jsx(Typography, { variant: "display-xs-semibold", sx: logoTextSx, children: SIDEBAR_STRINGS.backrs }), isEmulating && _jsx(EmulationChip, {})] }), _jsxs(Box, { sx: mobileNavItemWrapperSx, children: [mobileNavItems === null || mobileNavItems === void 0 ? void 0 : mobileNavItems.map(function (item, index) { return (_jsx(Box, { onClick: item.onClick, sx: menuIconSx, children: _jsx(AppIcon, { iconName: item.iconName, diameter: "24px", color: "currentColor" }) }, index)); }), _jsx(Box, { onClick: onMenuClick, sx: menuIconSx, children: _jsx(AppIcon, { iconName: "Menu02", diameter: "24px", color: "currentColor" }) })] })] })] }) }));
};
var containerSx = function (isEmulating) {
    return function (_a) {
        var backrs = _a.backrs;
        return ({
            display: { xs: 'flex', sm: 'none' },
            flexDirection: 'column',
            justifyContent: 'space-between',
            boxSizing: 'border-box',
            width: '100vw',
            height: SIDEBAR_MOBILE_HEIGHT,
            backgroundColor: backrs.colors['Colors/Background/bg-primary'],
            py: backrs.spacing['spacing-lg'],
            pr: backrs.spacing['spacing-md'],
            pl: backrs.containerSpacing['container-padding-mobile'],
            borderBottom: isEmulating
                ? "2px solid ".concat(backrs.colors['Colors/Foreground/fg-success-secondary'])
                : "1px solid ".concat(backrs.colors['Colors/Base/Black']),
            position: 'fixed',
            top: 0,
            zIndex: 1200,
        });
    };
};
var logoContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        gap: backrs.spacing['spacing-lg'],
        display: 'flex',
        transition: 'all 0.3s ease-in-out',
    });
};
var backrsLogoImageSx = {
    cursor: 'pointer',
    height: ICON_SIZES['32px'],
    width: ICON_SIZES['32px'],
};
var logoTextContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        gap: backrs.spacing['spacing-lg'],
    });
};
var logoTextWithChipSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        alignItems: 'center',
        minWidth: 0,
        overflow: 'hidden',
        gap: backrs.spacing['spacing-md'],
    });
};
var logoTextSx = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};
var mobileNavItemWrapperSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        gap: backrs.spacing['spacing-none'],
        display: 'flex',
        flexShrink: 0,
    });
};
var menuIconSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        cursor: 'pointer',
        borderRadius: backrs.radius['radius-full'],
        px: backrs.spacing['spacing-md'],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'center',
        color: backrs.colors['Colors/Foreground/fg-secondary'],
        transition: 'all 0.3s ease-in-out',
    });
};
